var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'lbz-radio',
    _vm.color && ("lbz-radio--" + _vm.color),
    _vm.onBackground && ("lbz-radio--on-" + _vm.onBackground),
    _vm.darkened && 'lbz-is-darkened',
    _vm.cisChecked && 'lbz-is-checked',
    _vm.disabled && 'lbz-is-disabled'
  ],on:{"click":function($event){$event.stopPropagation();!_vm.disabled && _vm.$emit('change', _vm.value, $event)}}},[_c('button',{staticClass:"lbz-radio__container"},[_c('input',_vm._b({},'input',{
        id: ("" + _vm.id),
        type: 'radio',
        value: _vm.value,
        checked: _vm.cisChecked,
        disabled: _vm.disabled
      },false)),_c('div',{staticClass:"lbz-radio__circle"}),(!_vm.disabled)?_c('lbz-state',_vm._b({},'lbz-state',_vm.cgetStateAttrs,false)):_vm._e()],1),(_vm.$slots.default)?_c('label',{staticClass:"lbz-radio__label",attrs:{"for":("" + _vm.id)}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }